import axios from "../../axios-config"

// create mix analyst report
export const createMixAnalysisReport = async (body) => {
  const res = await axios.post(
    "/audio-engineer/v1/create-mix-analysis",
    body
  );
  return res.data;
};

// generate or show mix analysis report
export const updateMixAnalysisReport = async (body) => {
  const res = await axios.post(
    "/audio-engineer/v1/mix-analyst-report",
    body
  );
  return res.data;
};

// retrieve mix analyst report of a track
export const getMixAnalysisReport = async (id) => {
  const res = await axios.get(
    `/audio-engineer/v1/mix-report-by-id/${id}`
  );
  return res.data;
};